import styled from 'styled-components';
import { breakpoints, colors, getTypography, pxToCssFont, pxToRem } from '@vfit/shared/themes';

export const Container = styled.div`
  display: flex;
  align-content: center;
  width: ${pxToRem(327)};
  border: 1px solid #bebebe;
  margin: 0 auto;
  gap: 24px;
  border-radius: 20px;

  @media (min-width: ${breakpoints.tablet}) {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: ${pxToRem(1280)};
  }

  @media (min-width: ${breakpoints.desktop}) {
    border-radius: 20px;
    width: 100%;
    max-width: ${pxToRem(1280)};
  }
`;

export const DescriptionCard = styled.div`
  padding: ${pxToRem(24)};
  @media (min-width: ${breakpoints.tablet}) {
    text-align: center;
    padding: ${pxToRem(24)};
    width: 100%;
    max-width: ${pxToRem(1280)};
  }

  @media (min-width: ${breakpoints.desktop}) {
    text-align: left;
    width: 60%;
    padding: ${pxToRem(64, 0, 64, 80)};
  }
`;

export const QRCodeCard = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  background: rgb(242, 242, 242);
  width: ${pxToRem(405)};
  border-radius: 0 20px 20px 0;

  @media (min-width: ${breakpoints.tablet}) {
    margin-left: 0;
  }
`;

export const QRCode = styled.div`
  margin: auto;
  width: 120%;
  height: 100%;
  img {
    border-radius: 0 20px 20px 0;
  }
`;

export const StoreContainer = styled.div`
  display: flex;
  margin-left: ${pxToRem(0)};
  flex-direction: column;
  justify-content: space-around;
  @media (min-width: ${breakpoints.tablet}) {
    display: flex;
    flex-direction: row;
    margin-top: ${pxToRem(24)};
    margin-bottom: ${pxToRem(24)};
  }
  @media (min-width: ${breakpoints.desktop}) {
    display: flex;
    flex-direction: row;
    margin-top: ${pxToRem(32)};
    margin-bottom: ${pxToRem(32)};
    margin-left: ${pxToRem(0)};
  }
`;

export const PlatformContainer = styled.div`
  display: flex;
  gap: 46px;

  @media (min-width: ${breakpoints.desktop}) {
    margin-top: ${pxToRem(30)};
  }
`;

export const Store = styled.div`
  margin-bottom: ${pxToRem(24)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media (min-width: ${breakpoints.tablet}) {
    margin-bottom: 0;
  }
  img {
    margin-right: ${pxToRem(5)};
  }
  span {
    @media (min-width: ${breakpoints.tablet}) {
      width: ${pxToRem(180)};
      height: auto;
      align-content: center;
      display: block;
      height: 48px;
      font-family: Vodafone;
      font-size: 18px;
      font-weight: 400;
      line-height: 24px;
      text-align: center;
    }
  }
`;

export const ButtonContainerDesktop = styled.div`
  padding-right: ${pxToRem(20)};
  display: flex;
  padding-top: ${pxToRem(20)};
  gap: 16px;
`;

export const ButtonContainerMobile = styled.div`
  display: flex;
  flex-direction: column;
  // padding-right: ${pxToRem(20)};
  padding-top: ${pxToRem(24)};
  button {
    margin-bottom: 16px;
  }
`;

export const ButtonContainerTablet = styled.div`
  padding-right: ${pxToRem(20)};
  display: flex;
  padding-top: ${pxToRem(24)};
  gap: 24px;
  align-items: center;
  justify-content: center;
`;

export const DisclaimerContainer = styled.div`
  color: ${colors.$0d0d0d};
  font-family: Vodafone;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  margin-top: ${pxToRem(24)};
  margin-bottom: ${pxToRem(20)};
  padding-right: ${pxToRem(20)};

  a {
    color: ${colors.$262626};
    font-weight: 700;

    &:hover {
      color: ${colors.$e60000};
    }
  }
  
  @media (min-width: ${breakpoints.tablet}) {
    margin-top: ${pxToRem(24)};
    margin-bottom: ${pxToRem(0)};
    display: block;
  }
`;

export const Title = styled.div`
  p {
    b {
      ${getTypography('h4.extrabold')}
    }
    ${getTypography('h4.light')}
  }

  p {
    margin: 0;
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(36, 48)}
  }
`;

export const MainContainer = styled.div`
  margin: 25px;
  margin-top: 50px;
  margin-bottom: 120px;
`;
